import GooglePayButton from '@google-pay/button-react';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { payWithGooglePayThunk } from '../thunks/payment';
import { googlePayAllowedPaymentMethods } from '../config';
import config from '../config';

export function GooglePayForm() {
    const cart: Cart = useSelector((state: AppState) => state.cart);
    const dispatch: ThunkDispatch<AppState, void, AnyAction> = useDispatch();
    const [error, setError] = useState<string | null>(null);
    const [isReady, setIsReady] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const paymentRequest = useMemo<google.payments.api.PaymentDataRequest>(() => ({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: googlePayAllowedPaymentMethods,
        merchantInfo: {
            merchantId: config.google_pay.maya_merchant_id,
            merchantName: config.google_pay.merchant_name,
        },
        transactionInfo: {
            totalPriceStatus: 'FINAL',
            totalPrice: cart.totalAmount.toFixed(2),
            currencyCode: 'PHP',
            countryCode: 'PH',
        },
        emailRequired: true,
        shippingAddressRequired: true,
        shippingAddressParameters: { phoneNumberRequired: true },
    }), [cart.totalAmount]);

    return (
        <div className="google-pay-container">
            {!isReady && <div className="google-pay-skeleton" />}
            <GooglePayButton
                environment={config.google_pay.environment}
                paymentRequest={paymentRequest}
                onReadyToPayChange={({ isReadyToPay }) => setIsReady(isReadyToPay)}
                onLoadPaymentData={async (paymentData) => {
                    if (isProcessing) return;
                    setIsProcessing(true);
                    setError(null);
                    try {
                        await dispatch(payWithGooglePayThunk(paymentData, cart.totalAmount));
                    } finally {
                        setIsProcessing(false);
                    }
                }}
                onError={() => {
                    setError('Google Pay is unavailable. Please select another payment method.');
                    setIsProcessing(false);
                }}
                buttonType="plain"
                buttonColor="black"
                buttonSizeMode="fill"
                style={{
                    width: '100%',
                    marginTop: '1em',
                    display: isReady ? undefined : 'none',
                    pointerEvents: isProcessing ? 'none' : undefined,
                    opacity: isProcessing ? 0.5 : undefined,
                }}
            />
            {isProcessing && <div className="bar-loader" style={{ marginTop: '1em' }} />}
            {error && <p className="google-pay-error">{error}</p>}
        </div>
    );
}
